import React from "react";
import "./Header.css";
import { Link } from "@reach/router";
import { NavLink } from "../components/NavLink";
import { FormattedMessage } from "react-intl";
import { appendLocale } from "../utils";

export const Header = props => {
  const { locale, location } = props;
  const path = location.pathname;
  const query = location.search;
  return (
    <header className='Header' role='banner'>
      <div className='heading'>
        <div className='topBar'>
          <ul>
            <li>
              <Link to={appendLocale(path, "fi", query)}>Suomi</Link>
            </li>
            <li>
            </li>
            <li>
              <Link to={appendLocale(path, "sv", query)}>Svenska</Link>
            </li>
          </ul>
        </div>
        <div className='logoContainer'>
          <img
            src='https://tukes.fi/documents/5470659/5962634/Tukes+Logo+outline.svg/64139461-e9d3-4c06-beef-788e43ffcced'
            alt='Tukes logo'
          />
        </div>
      </div>
      <nav className='mainNavigation'>
        <ul className='menubar'>
          <li>
            <NavLink to={appendLocale("", locale)}>
              <span> Etusivu</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={appendLocale("/toiminnanharjoittajat", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.OperatorRegistryNavigation' />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to={appendLocale("/kylma-alan-patevyys", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.RefrigerationCompetencyRegistryNavigation' />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to={appendLocale("/ruiskuntestaajan-patevyys", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.SprayTesterCompetencyRegistryNavigation' />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to={appendLocale("/kasvinsuojelukoulutuksen-ja-tutkinnonjarjestajan-patevyys", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.PesticideInstructorTrainerRegistryNavigation' />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to={appendLocale("/tuholaistorjunnan-toiminnanharjoittajat", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.PestControlOperatorRegistryNavigation' />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to={appendLocale("/tuholaistorjunnan-patevyys", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.PestControlCompetencyRegistryNavigation' />
              </span>
            </NavLink>
          </li>          
          <li>
            <NavLink to={appendLocale("/nimileimat", locale)}>
              <span>
                {" "}
                <FormattedMessage id='common.NameStampRegistryNavigation' />
              </span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/Layout/Header.js